import app from 'flarum/common/app';

app.initializers.add('peruguitar/user-portrait', () => {
    console.log('[peruguitar/user-portrait] Hello, forum and admin!');
});
